import React, { useMemo, useState } from "react";
import { ShieldCheck, ShieldAlert, ChevronDown } from "lucide-react";
import { auditOutputs } from "../lib/audit";
import * as m from "../lib/model";

const fmtV = (v) => (Math.abs(v) >= 1000 ? m.fmt$(v) : Number(v).toFixed(4));

export const AuditBadge = ({ V }) => {
  const [open, setOpen] = useState(false);
  const res = useMemo(() => { try { return auditOutputs(V); } catch (e) { return { checks: 0, fails: [{ label: `Audit crashed: ${e.message}`, model: 0, hand: 0 }], clean: false }; } }, [V]);
  if (res.skipped) return null;
  const n = res.fails.length;
  return (
    <div className="audit-wrap">
      <button className={`audit-badge ${res.clean ? "ok" : "bad"}`} onClick={() => setOpen((o) => !o)} data-testid="audit-badge"
        title={res.clean ? "Every headline output re-derived by hand and tied to the model" : "Some outputs no longer tie to their formulas"}>
        {res.clean ? <ShieldCheck size={12} /> : <ShieldAlert size={12} />}
        <span data-testid="audit-badge-text">{res.clean ? `Formulas verified · ${res.checks} checks` : `${n} tie-out break${n > 1 ? "s" : ""} · ${res.checks} checks`}</span>
        <ChevronDown size={11} style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform .15s" }} />
      </button>
      {open && (
        <div className="audit-pop" data-testid="audit-pop">
          <div className="audit-pop-head">Live tie-out · this deal, this scenario</div>
          <div className="om-sub" style={{ marginBottom: 8 }}>S&amp;U balance, amortisation, CFADS/DSCR, every projection year, exit equity, MOIC/IRR (NPV = 0), LP waterfall conservation, investor calculator, roll-up entry and recap maths — all recomputed from first principles on every change.</div>
          {res.clean ? <div className="audit-ok" data-testid="audit-clean">All {res.checks} checks tie.</div> : (
            <table className="tbl audit-tbl" data-testid="audit-fails">
              <thead><tr><th>Check</th><th className="num">Model</th><th className="num">By hand</th></tr></thead>
              <tbody>{res.fails.map((f) => <tr key={f.label}><td>{f.label}</td><td className="num">{fmtV(f.model)}</td><td className="num">{fmtV(f.hand)}</td></tr>)}</tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};
